import { render } from "./Calendario.vue?vue&type=template&id=8221a22e&ts=true"
import script from "./Calendario.vue?vue&type=script&lang=ts"
export * from "./Calendario.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__